// extracted by mini-css-extract-plugin
var _1 = "TopicPosts-module__animatedBackground--chED8";
var _2 = "TopicPosts-module__isEditing--zwxXd";
var _3 = "TopicPosts-module__subtopicHeader--DuSMq";
export { _1 as "animatedBackground", _2 as "isEditing", _3 as "subtopicHeader" }
